import { SyntheticEvent } from 'react';

export default class EventUtils {
  public static stopPropagation(event: SyntheticEvent): void {
    event.stopPropagation();
  }
}
